import tap from 'tap-logger'
import R from 'ramda'
export const $getFontSize = $elem => parseInt(R.path([0, 'style', 'font-size'], $elem) || $elem.css('font-size')) // Tenemos que hacer este || por un bug en jQuery o Chrome, donde en est buscador, de pronto ya jQuery traer el font-size del stylesheet y no la renderizada
const $setFontSize = ($elem, fz) => $elem.css('font-size', fz+'px')
//SE QUEDAN TODOS LOS LOGS Y EL CONTADOR POR DESARROLLO, si esto llega a produccion, borar
// let i = {count : 0}
// window.i = i 
export const fontSizer =
	(main_container_width, main_container_height, $reference_container, $line1, $line2, going = 'nowhere') => {
		
		// if(tap(i.count) === 300) {
		// 	// i=0
		// 	return
		// }
		let current_height = $reference_container.height()
		let current_width = $reference_container.width()
		let width_exceeded = current_width > main_container_width
		let hight_exceeded = current_height > main_container_height

		let fzl1 = $getFontSize($line1)
		let fzl2 = $getFontSize($line2)
		
		if (current_width === 0) {
			// console.log('DONE fz'+$line1[0].id,  fzl1)
			return 
		}
		if ((width_exceeded || hight_exceeded) && going === 'up') {
			// console.log('UP fz'+$line1[0].id,  fzl1)
			// i.count++
			$setFontSize($line1, fzl1 - 1)
			$setFontSize($line2, fzl2 - 1)
			return fzl1
		}

		if (width_exceeded || hight_exceeded) {
			// console.log('DOWN fz'+$line1[0].id,  fzl1)
			// i.count++
			$setFontSize($line1, fzl1 - 1)
			$setFontSize($line2, fzl2 - 1)
			fontSizer(main_container_width, main_container_height, $reference_container, $line1, $line2, 'down')
			return fzl1
		}

		if (!(width_exceeded || hight_exceeded)) {
			// console.log('TESTINGNEXT fz'+$line1[0].id,  fzl1)
			// console.log("width_exceeded ", width_exceeded);
			// console.log("hight_exceeded ", hight_exceeded);
			// console.log("main_container_width ", main_container_width);
			// console.log("current_width ", current_width);
			// console.log("main_container_height ", main_container_height);
			// console.log("current_height ", current_height);
			// i.count++
			$setFontSize($line1, fzl1 + 1)
			$setFontSize($line2, fzl2 + 1)
			fontSizer(main_container_width, main_container_height, $reference_container, $line1, $line2, 'up')
			return fzl1
		}

		return fzl1
	}


//scaleStyle :: {height, widht} -> {height, width} -> {transform: scale, ... }
export const scaleStyle = (parentStyles, container) => {
	let {height, width} = parentStyles
	let scale_ = Math.min(height/container.height, width/container.width) || 1
	let scale = `scale(${scale_}) translateX(-50%)`
	return {
		transform: scale,
		'transform-origin': '0 0 0',
		position: 'absolute',
		left: '50%'
	}
}


export const selectSlider = function(selector){
	return new Swiper(selector, {
		observer: true, 
		effect: 'slide',
		spaceBetween: 10,
		slidesPerView: 4,
		navigation: {
			nextEl: selector + ' .button__next_JS',
			prevEl: selector + ' .button__prev_JS',
		},
		breakpoints: {
			480: {
				slidesPerView: 2,
			},
			600: {
				slidesPerView: 4,
			},
			768: {
				slidesPerView: 3,

			}
		},
		slideToClickedSlide: false,
		on: {
			init() {
				setTimeout(() => {//hack para hacer que el slider siempre se reinicialice mostrando la primera slide. Los sliders se reinicializan cuando cambian las imagenes en ellos
					this.slideTo(this.slides.length - 1)
					this.slideTo(0)
				}, 200)
			}
		}
	 });
};


